import { useEffect, useState } from "react";
import { motion, useScroll, useSpring } from "framer-motion";
import { useLanding } from "@/context/LandingContext";
import { SEMINAR } from "@/seminars";
import { Brand } from "./Brand";

export function ScrollProgress() {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, { stiffness: 120, damping: 24, mass: 0.3 });
  return <motion.div className="scroll-progress" style={{ scaleX }} aria-hidden="true" />;
}

export function LanguageSwitch({ sfx = "", light = false }) {
  const { t, lang, setLang } = useLanding();
  return (
    <div className={`language-switch ${light ? "light" : ""}`} role="group" aria-label={t.nav.langLabel} data-testid={`language-switch${sfx}`}>
      <button className={`lang-btn ${lang === "en" ? "active" : ""}`} type="button" aria-pressed={lang === "en"} onClick={() => setLang("en")} data-testid={`lang-en-btn${sfx}`}>
        EN
      </button>
      <button className={`lang-btn ${lang === "zh" ? "active" : ""}`} type="button" aria-pressed={lang === "zh"} onClick={() => setLang("zh")} data-testid={`lang-zh-btn${sfx}`}>
        中文
      </button>
    </div>
  );
}

export function SiteNav() {
  const { t, setRegisterOpen } = useLanding();
  return (
    <header className="site-nav">
      <div className="container nav-inner">
        <Brand />
        <nav className="nav-links" aria-label="Registration">
          <span className="nav-context">{t.nav.context}</span>
          <LanguageSwitch />
          <button type="button" className="btn btn-gold nav-mini" onClick={() => setRegisterOpen(true)} data-testid="nav-reserve-btn">
            {SEMINAR.registrationClosed ? t.closed.cta : t.nav.reserve}
          </button>
        </nav>
      </div>
    </header>
  );
}

export function CompactNav() {
  const { t, setRegisterOpen } = useLanding();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const update = () => setVisible(window.scrollY > 140);
    window.addEventListener("scroll", update, { passive: true });
    update();
    return () => window.removeEventListener("scroll", update);
  }, []);

  return (
    <div className={`compact-nav ${visible ? "visible" : ""}`} aria-hidden={!visible} data-testid="compact-nav">
      <div className="container compact-nav-inner">
        <Brand testId="compact-brand" className="compact-brand" />
        <div className="compact-nav-actions">
          <LanguageSwitch sfx="-sticky" />
          <button type="button" className="btn btn-gold nav-mini compact-reserve" tabIndex={visible ? 0 : -1} onClick={() => setRegisterOpen(true)} data-testid="compact-reserve-btn">
            {SEMINAR.registrationClosed ? t.closed.cta : t.nav.reserve}
          </button>
        </div>
      </div>
    </div>
  );
}
